import { render } from "./OrganizationEdit.vue?vue&type=template&id=b3b2251a&scoped=true"
import script from "./OrganizationEdit.vue?vue&type=script&lang=js"
export * from "./OrganizationEdit.vue?vue&type=script&lang=js"

import "./OrganizationEdit.vue?vue&type=style&index=0&id=b3b2251a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b2251a"]])

export default __exports__